const faqs = [
  {
    q: '黑桃视频是免费的吗？需要注册吗？',
    a: '黑桃视频完全免费，无需注册登录即可在线观看西瓜视频免费、丝瓜视频等平台的高清影视内容。所有资源均为聚合整理，不收取任何费用。',
  },
  {
    q: '为什么叫“不缓冲”？播放真的不会卡顿吗？',
    a: '黑桃视频采用先进的智能带宽适配技术，根据你的网络环境自动调整最佳画质，配合CDN加速节点，确保流畅播放体验。正常情况下不会出现卡顿缓冲现象。',
  },
  {
    q: '黑桃视频和西瓜视频、丝瓜视频是什么关系？',
    a: '黑桃视频是一个影视资源聚合导航平台，精选整理西瓜视频免费资源、丝瓜视频高清内容等多家平台优质影视，为用户提供一站式的影视浏览和发现体验。',
  },
  {
    q: '支持哪些设备观看？可以在电视上看吗？',
    a: '黑桃视频网页版支持所有主流设备：电脑、平板、手机均可流畅访问。如需在电视上观看，可通过手机投屏功能或电视浏览器打开本站，即可享受大屏观影。',
  },
  {
    q: '每天更新多少部影片？多久更新一次？',
    a: '黑桃视频每日更新200+部最新电影电视剧，包括热播剧集、最新电影、综艺节目、动漫番剧等。更新频率为每日同步，确保你第一时间看到最新内容。',
  },
  {
    q: '如果遇到播放问题或想推荐影片，怎么联系？',
    a: '你可以通过页面中的「联系我们」区域查看投稿与合作方式，或发送邮件至 contact@heitao.视频，我们会在24小时内回复处理你的反馈和建议。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            关于黑桃视频，你可能想了解的事情
          </p>
        </div>

        <div className="max-w-[800px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-4">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-background-300/80 transition-colors duration-200"
            >
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-question-line text-primary-500 text-sm"></i>
                </div>
                <div>
                  <h3 className="text-sm font-medium text-foreground-900 mb-2">{faq.q}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}